import { render, staticRenderFns } from "./VASChannelSetting.vue?vue&type=template&id=6886cb60&scoped=true&"
import script from "./VASChannelSetting.vue?vue&type=script&lang=js&"
export * from "./VASChannelSetting.vue?vue&type=script&lang=js&"
import style0 from "./VASChannelSetting.vue?vue&type=style&index=0&id=6886cb60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6886cb60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6886cb60')) {
      api.createRecord('6886cb60', component.options)
    } else {
      api.reload('6886cb60', component.options)
    }
    module.hot.accept("./VASChannelSetting.vue?vue&type=template&id=6886cb60&scoped=true&", function () {
      api.rerender('6886cb60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/basicConfig/VASChannelSetting.vue"
export default component.exports